export var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["LoginRequired"] = "login_required";
})(ErrorCodes || (ErrorCodes = {}));
